document.addEventListener("DOMContentLoaded", function () {
  const languageSelect = document.getElementById("language-select");

  languageSelect.addEventListener("change", function () {
    const selectedLanguage = this.value;
    window.location.href = selectedLanguage; // Redirige a la URL seleccionada
  });
});
